import {PageHeaderProps} from './types';
import {PageHeaderWrapper} from './styles';

import {Div, FlexRow, H1, Span} from '@quarks';
import {Button, IconButton} from '@molecules';

export const PageHeader = ({buttonIcons, className, style, title, ...props}: PageHeaderProps) => {
  return (
    <PageHeaderWrapper
      className={className}
      style={style}
      {...props}>
      <H1
        sm={{
          gridArea: 'title',
        }}>
        {title}
      </H1>
      {buttonIcons?.length && (
        <FlexRow
          gridArea="button"
          justifyContent="flex-end"
          gap={8}>
          {buttonIcons.map(({icon, label, onClick, showButton}) => {
            return (
              <Span key={icon + label}>
                {showButton === 'all' || showButton === 'desktop' ? (
                  <Div sm={{display: 'none'}}>
                    <Button
                      button="tertiary"
                      iconRight={icon}
                      onClick={onClick}>
                      {label}
                    </Button>
                  </Div>
                ) : null}
                {showButton === 'all' || showButton === 'mobile' ? (
                  <Div
                    display="none"
                    sm={{display: 'flex', gridArea: 'button', justifySelf: 'flex-end'}}>
                    <IconButton
                      aria-label={label}
                      icon={icon}
                      iconButton="tertiary"
                      onClick={() => onClick()}
                    />
                  </Div>
                ) : null}
              </Span>
            );
          })}
        </FlexRow>
      )}
    </PageHeaderWrapper>
  );
};
